export default {
  mobileBanner: 1500,
  header: 1400,
  footer: 1380,
  modalOverlay: 1390,
}
